import { VEHICLE_ON_RESET_VEHICLE_DATA, VEHICLE_ON_RESET_VEHICLE } from "../../vehicle";
import { VEHICLE_CONFIGURATION_ATTRIBUTES_GET_REQUEST, VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS, VEHICLE_CONFIGURATION_ATTRIBUTES_GET_FAILURE } from '../actions';
export const vehicleConfigurationAttributesRootReducer = (state = {}, action) => {
    switch (action.type) {
        case VEHICLE_CONFIGURATION_ATTRIBUTES_GET_REQUEST: {
            return Object.assign(Object.assign({}, state), { isInProgress: true, errorMessage: '' });
        }
        case VEHICLE_CONFIGURATION_ATTRIBUTES_GET_SUCCESS: {
            return Object.assign(Object.assign(Object.assign({}, state), { isInProgress: false, errorMessage: '' }), action.payload);
        }
        case VEHICLE_CONFIGURATION_ATTRIBUTES_GET_FAILURE: {
            return Object.assign(Object.assign({}, state), { isInProgress: false, errorMessage: action.payload });
        }
        case VEHICLE_ON_RESET_VEHICLE:
        case VEHICLE_ON_RESET_VEHICLE_DATA: {
            return {};
        }
        default:
            return state;
    }
};
//# sourceMappingURL=vehicleConfigurationAttributesRootReducer.js.map